// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// Template
import template from "./template.vue";

import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";

import ModuleBase from "#/common/ModuleBase";
import { ModuleList } from "#/components/module_list/ModuleList";

@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
    ModuleList,
  },
})
export class PiLayerWrapperModule extends ModuleBase {
  private isVisible: boolean = false;
  private activeLayerId: string = "";

  getBackgroundColorFromInstance(instance: object) {
    return "black";
  }

  mounted() {
    this.$eventBus.$on("cms.pi_module.open", this.onOpenPiLayer);
  }

  beforeDestroy() {
    this.$eventBus.$off("cms.pi_module.open", this.onOpenPiLayer);
  }

  public onOpenPiLayer(activeLayerId) {
    this.isVisible = true;
    this.$store.ui.isNoScrollMode = true;
    this.activeLayerId = activeLayerId;
  }

  public onCloseLayer() {
    this.isVisible = false;
    this.$store.ui.isNoScrollMode = false;
    this.activeLayerId = "";
  }

  public findChildIndex(id) {
    return this.instance["__children"].findIndex((child) => {
      return child.content.element_id == id;
    });
  }

  get currentLayerIndex() {
    if (this.activeLayerId) {
      return this.findChildIndex(this.activeLayerId);
    } else {
      return -1;
    }
  }

  public onPrevLayer() {
    if (!this.isFirstLayer) {
      let prevIndex = this.currentLayerIndex - 1;
      this.activeLayerId =
        this.instance["__children"][prevIndex]["content"]["element_id"];
    }
  }

  public onNextLayer() {
    if (!this.isLastLayer) {
      let nextIndex = this.currentLayerIndex + 1;
      this.activeLayerId =
        this.instance["__children"][nextIndex]["content"]["element_id"];
    }
  }

  get isFirstLayer() {
    return this.currentLayerIndex == 0;
  }

  get isLastLayer() {
    return this.currentLayerIndex == this.instance["__children"].length - 1;
  }
}
